module.exports = __webpack_public_path__ + "media/images/pic/human-resources-3e20af4d33d4178b16bb7dfd33484639.jpg";